import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 17px;
`;

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 56.25% 0 0 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.a`
  color: #000;
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  text-decoration: none;
`;

export const Desc = styled.p`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const Info = styled.div`
  color: #9a98a0;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0.12px;
`;
